<template>
  <div>
    <ul class="afdc-nav afdc-nav-tabs afdc-nav-tabs-locator" role="tablist">
      <li class="afdc-nav-item">
        <router-link to="/find" event="" v-on:click.native.prevent="clickTabFind" v-bind:class="{ 'afdc-nav-link': true, 'afdc-active': isNavActiveTabFind }" id="afdc-find-tab" role="tab" aria-controls="find" v-bind:aria-selected="isNavActiveTabFind ? 'true' : 'false'">
          <div><font-awesome-icon icon="search" class="afdc-fa-icon afdc-tab-icon"/> {{ $t('Public Stations') }}</div>
        </router-link>
      </li>

      <li class="afdc-nav-item">
        <router-link to="/analyze" event="" v-on:click.native.prevent="clickTabAnalyze" v-bind:class="{ 'afdc-nav-link': true, 'afdc-active': isNavActiveTabAnalyze }" id="afdc-analyze-tab" role="tab" aria-controls="analyze" v-bind:aria-selected="isNavActiveTabAnalyze ? 'true' : 'false'">
          <div><font-awesome-icon icon="filter" class="afdc-fa-icon afdc-tab-icon"/> {{ $t('Advanced Filters') }}</div>
        </router-link>
      </li>

      <li class="afdc-nav-item" v-if="areCorridorsPresent === true">
        <router-link to="/corridors" event="" v-on:click.native.prevent="clickTabCorridors" v-bind:class="{ 'afdc-nav-link': true, 'afdc-active': isNavActiveTabCorridors }" id="afdc-corridors-tab" role="tab" aria-controls="corridors" v-bind:aria-selected="isNavActiveTabCorridors ? 'true' : 'false'">
          <div><font-awesome-icon icon="road" class="afdc-fa-icon afdc-tab-icon"/> {{ $t('Fuel Corridors') }}</div>
        </router-link>
      </li>
    </ul>

    <div class="afdc-tab-content">
      <div v-bind:class="{ 'afdc-tab-pane': true, 'afdc-active': isNavActiveTabFind }" id="afdc-find" role="tabpanel" aria-labelledby="afdc-find-tab">
        <find-stations/>
      </div>

      <div v-bind:class="{ 'afdc-tab-pane': true, 'afdc-active': isNavActiveTabAnalyze }" id="afdc-analyze" role="tabpanel" aria-labelledby="afdc-analyze-tab">
        <analyze-stations/>
      </div>

      <div v-if="areCorridorsPresent === true" v-bind:class="{ 'afdc-tab-pane': true, 'afdc-active': isNavActiveTabCorridors }" id="afdc-corridors" role="tabpanel" aria-labelledby="afdc-corridors-tab">
        <corridor-stations/>
      </div>
    </div>
  </div>
</template>

<script>
import FindStations from '@/components/FindStations.vue';
import AnalyzeStations from '@/components/AnalyzeStations.vue';
import CorridorStations from '@/components/CorridorStations.vue';

export default {
  components: {
    FindStations,
    AnalyzeStations,
    CorridorStations,
  },

  computed: {
    isNavActiveTabFind() {
      return this.$store.getters.isNavActiveTabFind;
    },

    isNavActiveTabAnalyze() {
      return this.$store.getters.isNavActiveTabAnalyze;
    },

    isNavActiveTabCorridors() {
      return this.$store.getters.isNavActiveTabCorridors;
    },

    areCorridorsPresent() {
      return this.$store.getters.isCorridorsPresent;
    },
  },

  methods: {
    switchToTab(routeName) {
      // Restore the filters for the tab we're switching to.
      const query = { ...this.$store.getters.getFiltersForScope(routeName) };
      // We treat the tab filters separately, with the exception of country,
      // which we'll sync between tabs (since this filter operates more
      // globally and exists outside the tabbed UI in the find mode).
      const activeCountry = this.$store.getters.getFilterValue('country');
      if (activeCountry) {
        query.country = activeCountry;
      } else {
        delete query.country;
      }

      this.$router.push({
        name: routeName,
        query,
      });
    },

    clickTabFind() {
      // Navigate to the find tab, remembering the last active mode and
      // filters.
      const findMode = this.$store.getters.getNavActiveFindMode;
      const routeName = (findMode === 'route') ? 'FindRouteStations' : 'FindNearestStations';
      this.switchToTab(routeName);
    },

    clickTabAnalyze() {
      // Navigate to the analyze tab, remembering the last active filters.
      const routeName = 'AnalyzeStations';
      this.switchToTab(routeName);
    },

    clickTabCorridors() {
      // Navigate to the corridors tab, remembering the last active filters.
      const routeName = 'CorridorStations';
      this.switchToTab(routeName);
    },
  },
};
</script>

<style lang="scss">
.clearboth {
  clear: both;
}

.form-control {
  height: auto;
}

.nav-tabs-locator .nav-item .nav-link {
  border: none;
  border-radius: 0px;
  margin-right: 10px;
  color: #fff;
  background-color: #555;

  &:hover {
    background-color: #777;
  }

  &.active {
    color: #333;
    background-color: #ccc;
    padding-bottom: 20px;
  }

  .fa-icon.tab-icon {
    margin: 5px 5px 0 0;
    float: left;
  }
}

#alt-fuel-station {
  position: absolute;
  z-index: 12;
  background-color: #fff;
  width: 90%;
  max-width: 1000px;
  height: 100%;
  overflow: auto;
  padding: 20px;
  border: 1px solid #ccc;
  -webkit-box-shadow: 5px 0px 10px 0px rgba(163, 163, 163, 1);
  -moz-box-shadow: 5px 0px 10px 0px rgba(163, 163, 163, 1);
  box-shadow: 5px 0px 10px 0px rgba(163, 163, 163, 1);

  .fa-icon {
    color: #666;
    clear: both;
  }

  .station-details-icon {
    color: #999;
    font-size: 40px;
  }

  #close-station {
    font-size: 32px;
    margin: -15px -5px -5px 0;
    .fa-icon {
      color: #999;
      &:hover {
        color: #666;
        cursor: pointer;
      }
    }
  }

  .station-port-connector {
    float: left;
    margin-right: 15px;
    img {
      height: 30px;
    }
  }

  td[headers="afdc-ports"] {
    text-align: center;
  }

  .directions-button {
    margin-bottom: 20px;
  }

  .station-error {
    width: calc(100% - 50px);
  }
}

</style>
